import { Link, type LinkProps } from '@mui/material';
import { type MouseEvent, type PropsWithChildren } from 'react';
import { chain } from '@/helpers/functional';

/**
 * A LinkButton is a wrapper around MUI's Link component that prevents the default link behavior and instead calls the provided onClick handler.
 * This is useful for cases where you want to use a link for styling purposes but don't want it to navigate to a new page.
 */
export const LinkButton = ({
  children,
  onClick,
  ...props
}: PropsWithChildren<Omit<LinkProps, 'onClick'> & { onClick: () => void }>) => (
  <Link href="#" onClick={chain(onDefaultClick, onClick)} variant="caption" underline="hover" {...props}>
    {children}
  </Link>
);

function onDefaultClick(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault();
}
